module.exports = __webpack_public_path__ + "Flama-MediumItalic.ttf?797d15183bc1f729566252c2d8c47195";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-MediumItalic.ttf
// module id = 892
// module chunks = 0